import HttpMethodType from "HttpMethodType";
import SubSystemType from "SubSystemType";
import BaseServiceRequest from "BaseServiceRequest";

export default class DeleteAlertRequest extends BaseServiceRequest {
  constructor(alertID) {
    super();
    super.addRequestUri("delete.pb");
    super.addPathParameter(alertID.toString());
  }

  getMethod() {
    return HttpMethodType.DELETE;
  }

  getSubSystem() {
    return SubSystemType.ALERTS;
  }

  getMessageName() {
    return "Response";
  }
}